import { Controller } from "@hotwired/stimulus"

// Lightbox-style video player for pet_postcards videos. Renders the <video>
// element on-demand on open (so we don't pay the metadata cost up-front for
// tiles the customer doesn't click), and removes it on close so playback
// fully stops and the network connection is freed.
//
// Mirrors the image modal pattern in modal_controller.js — tiles bind this
// controller with data-video-modal-url-value + data-action="click->video-modal#open",
// and the shared #video-modal partial also binds it for hide / hideOnBackdrop.
export default class extends Controller {
  static values = { url: String, title: String }

  open(event) {
    event.preventDefault()

    const modal = document.getElementById("video-modal")
    if (!modal) {
      console.error("video-modal element not found on page")
      return
    }

    const container = modal.querySelector("[data-video-modal-container]")
    const titleEl = modal.querySelector("[data-video-modal-title]")

    if (container) {
      const video = document.createElement("video")
      video.src = this.urlValue
      video.controls = true
      video.autoplay = true
      video.playsInline = true
      video.className = "w-full h-auto max-h-[80vh] bg-black"
      container.replaceChildren(video)
    }
    if (titleEl) titleEl.textContent = this.titleValue || ""

    modal.classList.remove("hidden")
    document.body.classList.add("overflow-hidden")
  }

  hide(event) {
    if (event) event.preventDefault()
    const modal = this.element.closest(".modal") || this.element
    this.teardown(modal)
  }

  hideOnBackdrop(event) {
    if (event.target === event.currentTarget) {
      this.hide(event)
    }
  }

  teardown(modal) {
    if (!modal) return
    const container = modal.querySelector("[data-video-modal-container]")
    if (container) container.replaceChildren() // removes <video>, stops playback
    modal.classList.add("hidden")
    document.body.classList.remove("overflow-hidden")
  }
}
